module.exports = __webpack_public_path__ + "img/1 (3).98e7485d.jpg";